import React, { useEffect, useRef } from 'react';
import { useDispatch , useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { setPage } from '../../redux/actions/commonActions';


export const ExitConfirm = () => {
  const dispatch = useDispatch();
  const { common, ui } = useSelector(state => state);

  const config = ui?.config?.attributes;
  const LeaveChat = config?.LeaveChat;


  useEffect(() => {
    dispatch(setPage('exit-confirm'))
    document.body.style.overflow = "auto";

    const timer = setTimeout(() => {
      clickBackChat(); // Trigger "No" option if no response after 5 seconds
    }, 5000);

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, [dispatch]);

  const clickBackChat = ()=>{
    dispatch(setPage('chat'))
  }

  const leaveChat = ()=>{
    window.close();
  }
  

  return  (
  <>
      <div className="leave-chat-wrapper">
          <div className="live-chat-container text-center mt-15">
              {/* <img src={ leaveChatImage } /> */}
              <h2>{ LeaveChat?.LeaveChatConfirmation }</h2>
              <button onClick={ leaveChat } className="btn-leave">{ LeaveChat?.Yes }</button>
              <button onClick={ clickBackChat} className="btn-leave">{ LeaveChat?.No }</button>
          </div>
      </div>

  </>
  )
}

export default ExitConfirm;